import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Company from '../../components/company/company.component';
import Spinner from '../../components/reusable/spinner/spinner.component';
import UpdateCompany from '../../components/company/update-company/update-company.component';

import Client from '../../tools/client';

import {
    BackLink,
    MainContainer,
    Text
} from '../../styles/page.styles';

const client = new Client();

const CompanyPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [ loading, setLoading ] = useState(true);
    const [ company, setCompany ] = useState([]);
    const [ showUpdate, setShowUpdate ] = useState(false);

    useEffect(() => {
        getCompany();

        // eslint-disable-next-line
    }, []);

    const getCompany = async () => {
        setLoading(true);
        const res = await client.getCompanyById(id);

        setCompany(res);
        setLoading(false);
    }

    return (
        <MainContainer>
            <BackLink onClick={() => navigate(`/companies`)}>Back to Companies</BackLink>
            {loading ?
                <Spinner />
            :
                !company ?
                    <Text>Account does not have associated company. Please contact support to set up an account associated company.</Text>
                :
                    showUpdate ?
                        <UpdateCompany company={company} getCompany={getCompany} setShowUpdate={setShowUpdate} />
                    :
                        <Company company={company} getCompany={getCompany} setShowUpdate={setShowUpdate} />
            }
        </MainContainer>
    )
}

export default CompanyPage;